import { render, staticRenderFns } from "./SetUpCurrency.vue?vue&type=template&id=19688b3e&"
import script from "./SetUpCurrency.vue?vue&type=script&lang=js&"
export * from "./SetUpCurrency.vue?vue&type=script&lang=js&"
import style0 from "./SetUpCurrency.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports